/**
 * reCAPTCHA v3 Configuration
 * Centralized configuration for Google reCAPTCHA v3 integration
 */

/**
 * reCAPTCHA Site Keys for different environments
 */
export const RECAPTCHA_SITE_KEYS = {
  // Production site key (replace with actual production key when available)
  production: "6LdOadsrAAAAAGaD3rG7kGOe0i7QcnmSqYPTFOUS",

  // Development/Testing site key
  development: "6LdOadsrAAAAAGaD3rG7kGOe0i7QcnmSqYPTFOUS",

  // Default site key (currently using the provided key)
  default: "6LdOadsrAAAAAGaD3rG7kGOe0i7QcnmSqYPTFOUS",
};

/**
 * reCAPTCHA Actions
 * Define different actions for reCAPTCHA verification
 */
export const RECAPTCHA_ACTIONS = {
  SUBMIT_APPLICATION: "submit_application"
};

/**
 * Get the appropriate reCAPTCHA site key based on environment
 * @param {string} environment - Environment name (development, production)
 * @returns {string} reCAPTCHA site key
 */
export const getRecaptchaSiteKey = (environment = process.env.NODE_ENV) => {
  const env = environment || "development";
  return RECAPTCHA_SITE_KEYS[env] || RECAPTCHA_SITE_KEYS.default;
};

/**
 * reCAPTCHA Configuration
 */
export const RECAPTCHA_CONFIG = {
  // Script URL for loading reCAPTCHA
  scriptUrl: "https://www.google.com/recaptcha/api.js",

  // Default score threshold (not used in v3 but kept for reference)
  scoreThreshold: 0.5,

  // Timeout for reCAPTCHA execution (milliseconds)
  executionTimeout: 10000,

  // Enable logging for debugging
  enableLogging: process.env.NODE_ENV === "development",
};

export default {
  RECAPTCHA_SITE_KEYS,
  RECAPTCHA_ACTIONS,
  RECAPTCHA_CONFIG,
  getRecaptchaSiteKey,
};
